import React, { Component } from "react";
import '../assets/fonts/google-fonts-config'
class JackpotElements extends Component {
  render() {
    const { background, elements } = this.props;
    return (
      <div style={background}>
        {elements.map((elem, i) => {
          // Handle video elements
          if (elem.type === 'video' && elem.backgroundVideo) {
            return (
              <div key={`element-${i}`} style={{...elem, backgroundImage: 'none', overflow: 'hidden'}}>
                <video
                  src={elem.backgroundVideo}
                  autoPlay={elem.videoAutoplay ?? true}
                  loop={elem.videoLoop ?? true}
                  muted={elem.videoMuted ?? true}
                  style={{
                    width: elem.width ?? '100%',
                    height: elem.height ?? '100%',
                    left: elem.left ?? 0,
                    top: elem.top ?? 0,
                    position: elem.position ?? 'absolute',
                    objectFit: elem.backgroundSize === 'contain' ? 'contain' : 'cover'
                  }}
                />
              </div>
            );
          }
          
          // Handle regular elements
          return (
            <div key={`element-${i}`} style={elem}>
              {elem.caption &&
                elem.caption !== "" &&
                (elem.captionPosition === "top" ||
                  elem.captionPosition === "left") && (
                  <div
                    style={{
                      display:
                        elem.captionPosition === "left"
                          ? "inline-block"
                          : "block",
                      fontSize: "0.6em",
                      lineHeight: "0.6em",
                      verticalAlign: "middle",
                      margin:
                        elem.captionPosition === "left"
                          ? "0em 0.4em"
                          : "0.2em 0em"
                    }}
                  >
                    {elem.caption}
                  </div>
                )}
              {elem.content}
              {elem.caption &&
                elem.caption !== "" &&
                (elem.captionPosition === "bottom" ||
                  elem.captionPosition === "right") && (
                  <div
                    style={{
                      display:
                        elem.captionPosition === "right"
                          ? "inline-block"
                          : "block",
                      fontSize: "0.6em",
                      lineHeight: "0.6em",
                      verticalAlign: "middle",
                      fontFamily: elem.fontFamily,
                      margin:
                        elem.captionPosition === "right"
                          ? "0em 0.4em"
                          : "0.2em 0em"
                    }}
                  >
                    {elem.caption}
                  </div>
                )}
            </div>
          );
        })}
      </div>
    );
  }
}

export default JackpotElements;
